import { render, staticRenderFns } from "./TcmPrintHerbalMedicineOrder.vue?vue&type=template&id=01da42e8&"
import script from "./TcmPrintHerbalMedicineOrder.vue?vue&type=script&lang=js&"
export * from "./TcmPrintHerbalMedicineOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports